export { default } from "./AgeRuleText";
